var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading"}):_c('RelatorioTable',{attrs:{"filtros":_vm.filtros}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }